import CommonThunk from '../models/CommonThunk';
import sunbitApi from '../services/sunbitApi';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';
import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import { isMobile } from '@sunbit-dev/common/helpers/user';
import { replace } from 'connected-react-router';
import urls from '../constants/urls';
import { VerificationActionTypes } from '../models/actions/verification';
import { datadogRum } from '@sunbit-dev/common/services/datadog';

const getVerifyLinkPending = () => ({
  type: VerificationActionTypes.getVerifyLink,
  status: ActionStatus.Pending,
});

const sendSMSLinkPending = () => ({
  type: VerificationActionTypes.sendSMSLink,
  status: ActionStatus.Pending,
});

const sendSMSLinkSuccess = () => ({
  type: VerificationActionTypes.sendSMSLink,
  status: ActionStatus.Success,
});

export const sendSMSLinkFailure = (error: ApplicationError) => ({
  type: VerificationActionTypes.sendSMSLink,
  status: ActionStatus.Success,
  error,
});

const getVerifyLinkSuccess = () => ({
  type: VerificationActionTypes.getVerifyLink,
  status: ActionStatus.Success,
});

export const setLinkForVerify = (verificationLink: string) => ({
  type: VerificationActionTypes.verify,
  verificationLink: verificationLink,
});

const verifyLinkFailure = (error: ApplicationError) => ({
  type: VerificationActionTypes.verifyLinkFailure,
  status: ActionStatus.Failure,
  error,
});


export const sendVerifySMS = (): CommonThunk => {
  return async (dispatch) => {
    try {
      dispatch(sendSMSLinkPending());
      await sunbitApi.sendVerificationSMSLink();
      dispatch(sendSMSLinkSuccess());
    } catch (error: unknown) {
      dispatch(sendSMSLinkFailure(error as ApplicationError));
    }
  };
};

export const handleVerification = (): CommonThunk => {
  return async (dispatch) => {
      try {
        dispatch(getVerifyLinkPending());
        const response = await sunbitApi.getVerificationLink();
        if (isMobile.any()) {
          datadogRum.addAction(`verification-redirect-to-verify-app`, {});
          window.onbeforeunload = null;
          window.location.assign(response.link);
        } else {
          dispatch(setLinkForVerify(response.link));
          dispatch(getVerifyLinkSuccess());
          dispatch(replace(urls.verification));
        }
      } catch (error: unknown) {
        dispatch(verifyLinkFailure(error as ApplicationError));
      }
  
  };
};

export type Actions = ReturnType<typeof setLinkForVerify>;
